

import axios from "axios";

export const QueryMethod=(URL,isRequestProcessing,data, method )=>{
  isRequestProcessing(true)
    let token = localStorage.getItem("MyToken")
    let response =axios({
      method: method,
      url: URL,
      data: data && data,
      headers: {
  
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin":"*",
          Authorization: `Bearer ${token}`,
      },
      timeout:10000,
      withCredentials: true
  })
  return response
    

}


export const checkInternetConnection=()=>{
  let headers = {mode: "no-cors"}
  return fetch("https://www.google.com", headers)
}

